/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Cname } from '../models/Cname';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomDomainService {
    /**
     * Add a new custom domain
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully added
     * @throws ApiError
     */
    public static postCname(
        workspaceId: string,
        requestBody: {
            domain_name: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cname',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of custom domains
     * @param workspaceId Workspace ID required
     * @returns Cname Successfully retrieved cname list
     * @throws ApiError
     */
    public static getCname(
        workspaceId: string,
    ): CancelablePromise<Cname> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cname',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes a custom domain
     * @param id The id of channel to get or delete
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted custom domain
     * @throws ApiError
     */
    public static deleteCname(
        id: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/cname/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Custom domain not found`,
                500: `Internal server error`,
            },
        });
    }
}
